import {
  createNavigatorFactory,
  ParamListBase,
  useNavigationBuilder,
} from '@react-navigation/native'

import {
  BottomSheetRouter,
  BottomSheetRouterOptions,
} from '@/components/navigation/bottomSheet/BottomSheetRouter'
import { BottomSheetView } from '@/components/navigation/bottomSheet/BottomSheetView'
import type {
  BottomSheetActionHelpers,
  BottomSheetNavigationEventMap,
  BottomSheetNavigationOptions,
  BottomSheetNavigationState,
  BottomSheetNavigatorProps,
} from '@/components/navigation/bottomSheet/types'

const BottomSheetNavigator = ({
  id,
  children,
  screenListeners,
  screenOptions,
  ...rest
}: BottomSheetNavigatorProps) => {
  const { state, descriptors, navigation, NavigationContent } =
    useNavigationBuilder<
      BottomSheetNavigationState<ParamListBase>,
      BottomSheetRouterOptions,
      BottomSheetActionHelpers<ParamListBase>,
      BottomSheetNavigationOptions,
      BottomSheetNavigationEventMap
    >(BottomSheetRouter, {
      id,
      children,
      screenListeners,
      screenOptions,
    })

  return (
    <NavigationContent>
      <BottomSheetView
        {...rest}
        descriptors={descriptors}
        navigation={navigation}
        state={state}
      />
    </NavigationContent>
  )
}

// eslint-disable-next-line import/prefer-default-export
export const createBottomSheetNavigator =
  createNavigatorFactory(BottomSheetNavigator)
